import { Assets } from "../../layers/Renderer/Phaser/phaserConstants";
import { useMUD } from "../../store";
import { useCurrentPlayer } from "./hooks/useCurrentPlayer";
import { usePlayerGold } from "./hooks/usePlayerGold";

export const GoldAmount = () => {
  const {
    phaserLayer: {
      scenes: {
        Main: {
          config: { assets },
        },
      },
    },
  } = useMUD();

  const currentPlayer = useCurrentPlayer();
  const { amount, regen } = usePlayerGold(currentPlayer);

  return (
    <div className="flex flex-col items-end text-[#CEA82C] w-[120px]">
      <div className="w-full text-right text-[#7E7E6D]">+{regen}g/turn</div>

      <div className="flex flex-col items-end">
        <div className="flex flex-row text-3xl justify-between w-ful items-center">
          <img className="mr-2 w-[24px] h-[24px]" src={assets[Assets.Gold].path} /> <span>{amount}g</span>
        </div>
      </div>
    </div>
  );
};
